import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { SearchFacesRequest } from 'src/app/model/SearchFacesRequest';
import { ProcessedImageService } from 'src/app/services/images.service';
import { SqlEditorComponent } from 'src/app/components/sql-editor/sql-editor.component';
import { DatabaseService } from 'src/app/services/database.service';
import { Person } from 'src/app/model/Person';
import { Router } from '@angular/router';
import { TitleService } from 'src/app/services/title.service';

@Component({
  selector: 'app-raw-person-search',
  templateUrl: './raw-search.component.html',
  styleUrls: ['./raw-search.component.css']
})
export class RawPersonSearchComponent implements OnInit, AfterViewInit {

  @ViewChild('editor') editor: SqlEditorComponent;

  title = 'Search for persons by defining where clause for SQL search';
  showLoader = false;
  persons: Person[];
  showMoreButton = false;
  totalCount: number;

  limit = 100;
  offset = 0;
  condition: string;

  orderText: string;
  errorText: string;


  constructor(
    private imageService: ProcessedImageService,
    private router: Router,
    private dbService: DatabaseService,
    private titleService: TitleService
  ) { }

  ngOnInit() {
    this.offset = 0;
    this.limit = 100;
    this.titleService.setTitle('Raw Person Search');
    this.loadTables();
  }

  ngAfterViewInit() {
    this.editor.setValue('WHERE p.name is not null');
  }

  queryChanged(q: string) {
    if (q && q != null) {
      console.log('New query: ' + q);
      this.condition = q;
    } else {
      this.condition = '';
    }
  }

  doSearch() {
    this.showLoader = true;
    this.condition = this.editor.getValue();
    this.imageService.searchPersons(this.condition, this.limit, this.offset).subscribe((p) => {
      this.persons = p.persons;
      this.totalCount = p.totalCount;
      this.showLoader = false;
      this.showMoreButton = (p.persons.length < p.totalCount);
      this.title = 'Showing ' + p.persons.length + ' of ' + p.totalCount +  ' persons that match parameters';
    }, (err) => {
      this.errorText = err.Error;
      this.showLoader = false;
    });
  }

  loadMoreFaces() {
    this.offset += this.limit;
    this.imageService.searchPersons(this.condition, this.limit, this.offset).subscribe((p) => {
      this.persons = this.persons.concat(p.persons);
      this.showLoader = false;
      this.showMoreButton = (this.persons.length < this.totalCount);
      this.title = 'Showing ' + this.persons.length + ' of ' + this.totalCount +  ' persons that match parameters';
    });
  }

  loadTables() {
    this.dbService.listTables().subscribe((t) => {
      this.editor.setTables(t);
    });
  }

  public showPerson(person) {
    this.router.navigate(['persons/' + person.id]);
  }


}
